// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonStyles-module__font-s-10___fOD8a {
  font-size: 10px !important;
}

.commonStyles-module__font-s-12___i1CPv {
  font-size: 12px !important;
}

.commonStyles-module__font-s-13___xbsZg {
  font-size: 13px !important;
}

.commonStyles-module__font-s-14___VvyfF {
  font-size: 14px !important;
}

.commonStyles-module__font-s-15___JyJQc {
  font-size: 15px !important;
}

.commonStyles-module__font-s-16___fxZC2 {
  font-size: 16px !important;
}

.commonStyles-module__font-s-18___TeDLM {
  font-size: 18px !important;
}

.commonStyles-module__font-s-20___KIluw {
  font-size: 20px !important;
}

.commonStyles-module__font-s-22___JP4l7 {
  font-size: 22px !important;
}

.commonStyles-module__font-s-28___Jb5_C {
  font-size: 28px !important;
}

.commonStyles-module__font-w-400___gs4vx {
  font-weight: 400 !important;
}

.commonStyles-module__font-w-500___m7jSl {
  font-weight: 500 !important;
}

.commonStyles-module__font-w-600___X4Kbv {
  font-weight: 600 !important;
}

.commonStyles-module__font-w-700___gHZxP {
  font-weight: 700 !important;
}

.commonStyles-module__p-5___x1sz_ {
  padding: 5px !important;
}

.commonStyles-module__p-12___crbHK {
  padding: 12px !important;
}

.commonStyles-module__p-16___NQRCX {
  padding: 16px !important;
}

.commonStyles-module__p-30___JPupD {
  padding: 30px !important;
}

.commonStyles-module__p-b-0___S1Nts {
  padding-bottom: 0 !important;
}

.commonStyles-module__p-b-5___TO67k {
  padding-bottom: 5px !important;
}

.commonStyles-module__p-b-10___DwQsD {
  padding-bottom: 10px !important;
}

.commonStyles-module__p-b-12___I1_6Y {
  padding-bottom: 12px !important;
}

.commonStyles-module__p-b-16___akhnk {
  padding-bottom: 16px !important;
}

.commonStyles-module__p-b-18___Vj3b7 {
  padding-bottom: 18px !important;
}

.commonStyles-module__p-b-20___ZeKGa {
  padding-bottom: 20px !important;
}

.commonStyles-module__p-b-25___svoQE {
  padding-bottom: 25px !important;
}

.commonStyles-module__p-b-30___tHpoc {
  padding-bottom: 30px !important;
}

.commonStyles-module__p-b-50___fAJHz {
  padding-bottom: 50px !important;
}

.commonStyles-module__p-t-0___CWbnC {
  padding-top: 0 !important;
}

.commonStyles-module__p-t-12___KymsU {
  padding-top: 12px !important;
}

.commonStyles-module__p-t-16___rWOdT {
  padding-top: 16px !important;
}

.commonStyles-module__p-t-18___JmZSN {
  padding-top: 18px !important;
}

.commonStyles-module__p-t-20___wRfmz {
  padding-top: 20px !important;
}

.commonStyles-module__p-t-30___RzBw6 {
  padding-top: 30px !important;
}

.commonStyles-module__p-t-40___RZ4rO {
  padding-top: 40px !important;
}

.commonStyles-module__p-t-50___VyZN2 {
  padding-top: 50px !important;
}

.commonStyles-module__p-l-20___zL91K {
  padding-left: 20px !important;
}

.commonStyles-module__p-l-30___BSnC0 {
  padding-left: 30px !important;
}

.commonStyles-module__p-l-40___aiJMH {
  padding-left: 40px !important;
}

.commonStyles-module__p-r-16___a7mGe {
  padding-right: 16px !important;
}

.commonStyles-module__p-r-20___mvQTD {
  padding-right: 20px !important;
}

.commonStyles-module__p-r-30___Z1tFl {
  padding-right: 30px !important;
}

.commonStyles-module__p-r-50___s179c {
  padding-right: 50px !important;
}

.commonStyles-module__p-r-60___XiHrb {
  padding-right: 60px !important;
}

.commonStyles-module__m-b-1___Qk1A7 {
  margin-bottom: 1px !important;
}

.commonStyles-module__m-b-2___YhFZ3 {
  margin-bottom: 2px !important;
}

.commonStyles-module__m-b-6___vjzF1 {
  margin-bottom: 6px !important;
}

.commonStyles-module__m-b-8___yn64D {
  margin-bottom: 8px !important;
}

.commonStyles-module__m-b-10___uAQlc {
  margin-bottom: 10px !important;
}

.commonStyles-module__m-b-14___CAJ60 {
  margin-bottom: 14px !important;
}

.commonStyles-module__m-b-16___RwNLm {
  margin-bottom: 16px !important;
}

.commonStyles-module__m-b-20___OgsTK {
  margin-bottom: 20px !important;
}

.commonStyles-module__m-b-22___EJC84 {
  margin-bottom: 22px !important;
}

.commonStyles-module__m-b-24___NzCwJ {
  margin-bottom: 24px !important;
}

.commonStyles-module__m-b-30___F5bSE {
  margin-bottom: 30px !important;
}

.commonStyles-module__m-b-32___hmtoV {
  margin-bottom: 32px !important;
}

.commonStyles-module__m-b-40___RLYDK {
  margin-bottom: 40px !important;
}

.commonStyles-module__m-t-2____nUej {
  margin-top: 2px !important;
}

.commonStyles-module__m-t-3___e4l7F {
  margin-top: 3px !important;
}

.commonStyles-module__m-t-4___UkjNo {
  margin-top: 4px !important;
}

.commonStyles-module__m-t-5___ggUKD {
  margin-top: 5px !important;
}

.commonStyles-module__m-t-8___u1zgb {
  margin-top: 8px !important;
}

.commonStyles-module__m-t-10___QW5UT {
  margin-top: 10px !important;
}

.commonStyles-module__m-t-15___SIMop {
  margin-top: 15px !important;
}

.commonStyles-module__m-t-16___G7__R {
  margin-top: 16px !important;
}

.commonStyles-module__m-t-20___j1Jg7 {
  margin-top: 20px !important;
}

.commonStyles-module__m-t-22___vWJm1 {
  margin-top: 22px !important;
}

.commonStyles-module__m-t-30___vOmmn {
  margin-top: 30px !important;
}

.commonStyles-module__m-t-32___mDS5K {
  margin-top: 32px !important;
}

.commonStyles-module__m-l-auto___ZlqzJ {
  margin-left: auto !important;
}

.commonStyles-module__m-l-4___ncJOt {
  margin-left: 4px !important;
}

.commonStyles-module__m-l-5___pXoXc {
  margin-left: 5px !important;
}

.commonStyles-module__m-l-6___poXLB {
  margin-left: 6px !important;
}

.commonStyles-module__m-l-8___OJ6Hl {
  margin-left: 8px !important;
}

.commonStyles-module__m-l-10___nMNHP {
  margin-left: 10px !important;
}

.commonStyles-module__m-l-16___HN5L1 {
  margin-left: 16px !important;
}

.commonStyles-module__m-l-20___Ej8MW {
  margin-left: 20px !important;
}

.commonStyles-module__m-l-24___lxH1c {
  margin-left: 24px !important;
}

.commonStyles-module__m-l-30___I3KxA {
  margin-left: 30px !important;
}

.commonStyles-module__m-l-35____DFBR {
  margin-left: 35px !important;
}

.commonStyles-module__m-l-40___pj8ip {
  margin-left: 40px !important;
}

.commonStyles-module__m-r-8___D3c4a {
  margin-right: 8px !important;
}

.commonStyles-module__m-r-10___tYGlC {
  margin-right: 10px !important;
}

.commonStyles-module__m-r-16___pNRb7 {
  margin-right: 16px !important;
}

.commonStyles-module__m-r-20___YKhK4 {
  margin-right: 20px !important;
}

.commonStyles-module__m-r-24___O7dgd {
  margin-right: 24px !important;
}

.commonStyles-module__m-r-30___PpJJD {
  margin-right: 30px !important;
}

.commonStyles-module__m-r-40___bVPM9 {
  margin-right: 40px !important;
}

.commonStyles-module__border-r-3___jWOSG {
  border-radius: 3px !important;
}

.commonStyles-module__border-r-4___sEVEa {
  border-radius: 4px !important;
}

.commonStyles-module__border-r-6___gqgfo {
  border-radius: 6px !important;
}

.commonStyles-module__border-r-10___auUUN {
  border-radius: 10px !important;
}

.commonStyles-module__border-r-12___x3Qks {
  border-radius: 12px !important;
}

.commonStyles-module__border-r-16___oLpxu {
  border-radius: 16px !important;
}

.commonStyles-module__border-r-50___ewkz5 {
  border-radius: 50% !important;
}

.commonStyles-module__primary-border___rOEe7 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__primary-border-b___sJgPE {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__primary-border-t___mezW3 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__primary-border-l___uuNlR {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__primary-border-r___mns8z {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__secondary-border___CWkST {
  border: 1px solid #637768;
}

.commonStyles-module__secondary-border-b___fkw6m {
  border-bottom: 1px solid #637768;
}

.commonStyles-module__secondary-border-t___bo5U2 {
  border-top: 1px solid #637768;
}

.commonStyles-module__secondary-border-l___Zb0lV {
  border-left: 1px solid #637768;
}

.commonStyles-module__secondary-border-r___z_rQm {
  border-right: 1px solid #637768;
}

.commonStyles-module__gap-0___bzPD3 {
  gap: 0 !important;
}

.commonStyles-module__gap-2___ekOZ1 {
  gap: 2px !important;
}

.commonStyles-module__gap-4___TXxEo {
  gap: 4px !important;
}

.commonStyles-module__gap-5___L4ieK {
  gap: 5px !important;
}

.commonStyles-module__gap-6___n7QQS {
  gap: 6px !important;
}

.commonStyles-module__gap-8___P5n9z {
  gap: 8px !important;
}

.commonStyles-module__gap-10___EypVI {
  gap: 10px !important;
}

.commonStyles-module__gap-12___A6092 {
  gap: 12px !important;
}

.commonStyles-module__gap-14___Sj7GR {
  gap: 14px !important;
}

.commonStyles-module__gap-16___Qruby {
  gap: 16px !important;
}

.commonStyles-module__gap-18___uRwGR {
  gap: 18px !important;
}

.commonStyles-module__gap-20___OJ1Jx {
  gap: 20px !important;
}

.commonStyles-module__gap-24___Z8yMv {
  gap: 24px !important;
}

.commonStyles-module__gap-26___EKNjN {
  gap: 26px !important;
}

.commonStyles-module__gap-30___d7cSM {
  gap: 30px !important;
}

.commonStyles-module__gap-32___IhbVe {
  gap: 32px !important;
}

.commonStyles-module__gap-40___m5SaJ {
  gap: 40px !important;
}

.commonStyles-module__gap-50____AmzV {
  gap: 50px !important;
}

.commonStyles-module__flex-1___InhiG {
  flex: 1;
}

.commonStyles-module__flex-none___Vk0UU {
  flex: none !important;
}

.commonStyles-module__flex-column___QAVZA {
  display: flex;
  flex-direction: column !important;
}

.commonStyles-module__flex-row___qWV3g {
  display: flex;
  flex-direction: row !important;
}

.commonStyles-module__vertically-centered___V5Av7 {
  display: flex;
  align-items: center !important;
}

.commonStyles-module__horizontally-centered___slDYb {
  display: flex;
  justify-content: center !important;
}

.commonStyles-module__horizontally-end___o0mXy {
  display: flex;
  justify-content: end !important;
}

.commonStyles-module__vertically-start___Btf4Y {
  display: flex;
  align-items: start !important;
}

.commonStyles-module__space-between___KHoVv {
  display: flex;
  justify-content: space-between !important;
}

.commonStyles-module__flex-wrap___t9g1O {
  flex-wrap: wrap !important;
}

.commonStyles-module__height-100___ONsnK {
  height: 100%;
}

.commonStyles-module__width-50___QBMGB {
  width: 50% !important;
}

.commonStyles-module__width-100___gNYLm {
  width: 100%;
}

.commonStyles-module__cursor-pointer___xAvbC {
  cursor: pointer;
}

.commonStyles-module__cursor-not-allowed___cgLu6 {
  cursor: not-allowed !important;
}

.commonStyles-module__absolute-centered___ZECYn {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.commonStyles-module__absolute___mJu3N {
  position: absolute;
}

.commonStyles-module__relative___aIUJ_ {
  position: relative;
}

.commonStyles-module__fixed___AQEmA {
  position: fixed;
}

.commonStyles-module__visible___cfth9 {
  opacity: 1;
}

.commonStyles-module__invisible___F8jgn {
  opacity: 0;
}

.commonStyles-module__col-90___dO8li {
  width: 90% !important;
}

.commonStyles-module__col-auto___zsHMK {
  width: auto !important;
}

.commonStyles-module__medical-tabs___ulisv {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.commonStyles-module__medical-table-new___F08z7 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.commonStyles-module__medical-table-new___F08z7:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.commonStyles-module__medical-table-new___F08z7::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.commonStyles-module__medical-table-new___F08z7::-webkit-scrollbar-track {
  display: none;
}
.commonStyles-module__medical-table-new___F08z7.commonStyles-module__no-pagination___Clpnv {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.commonStyles-module__medical-table-new___F08z7.commonStyles-module__no-pagination___Clpnv:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.commonStyles-module__medical-table-new___F08z7.commonStyles-module__no-pagination___Clpnv::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.commonStyles-module__medical-table-new___F08z7.commonStyles-module__no-pagination___Clpnv::-webkit-scrollbar-track {
  display: none;
}

.commonStyles-module__medical-table-empty___Ha8la {
  padding: 14px 40px !important;
}

.commonStyles-module__icon-btn___K1ijf {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.commonStyles-module__search-icon___H4_P5 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.commonStyles-module__disable-select___ZWgiQ {
  user-select: none;
}

.commonStyles-module__break-word___nwAjB {
  word-break: break-word;
}

.commonStyles-module__popup-clear-btn___vcGyr {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.commonStyles-module__scroll-m-b-20___NzcI3 {
  scroll-margin-bottom: 20px;
}

.commonStyles-module__container___swhj1 {
  font-family: var(--font-family);
  font-weight: 700;
  line-height: 150%;
  color: white;
  padding: 2px 8px;
  border-radius: 17px;
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.commonStyles-module__actionsMenu___vNg9n {
  padding: 2px 10px;
}

.commonStyles-module__actionButton___c36fT {
  border: 1px solid #375844;
  border-radius: 6px;
  max-width: 30px;
  padding: 3px;
}

.commonStyles-module__link___mGWKc {
  color: #375844;
}

.commonStyles-module__preferred___nVTQd {
  color: #f1bf72;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/PatientDetailsNavigation/items/commonStyles.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EEwBE,+BApBO;EAqBP,gBCtBK;EHDL,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;AA+pBF;;AA5pBA;EACE,iBAAA;AA+pBF;;AA5pBA;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AA+pBF;;AA5pBA;EACE,cAAA;AA+pBF;;AA5pBA;EACE,cAAA;AA+pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  @include get-font($roboto, $bold);\n  line-height: 150%;\n  color: white;\n  padding: 2px 8px;\n  border-radius: 17px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n}\n\n.actionsMenu {\n  padding: 2px 10px;\n}\n\n.actionButton {\n  border: 1px solid get-color(greenNew, dark);\n  border-radius: 6px;\n  max-width: 30px;\n  padding: 3px;\n}\n\n.link {\n  color: get-color(greenNew, dark);\n}\n\n.preferred {\n  color: get-color(orangeNew, base);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `commonStyles-module__font-s-10___fOD8a`,
	"fontS12": `commonStyles-module__font-s-12___i1CPv`,
	"fontS13": `commonStyles-module__font-s-13___xbsZg`,
	"fontS14": `commonStyles-module__font-s-14___VvyfF`,
	"fontS15": `commonStyles-module__font-s-15___JyJQc`,
	"fontS16": `commonStyles-module__font-s-16___fxZC2`,
	"fontS18": `commonStyles-module__font-s-18___TeDLM`,
	"fontS20": `commonStyles-module__font-s-20___KIluw`,
	"fontS22": `commonStyles-module__font-s-22___JP4l7`,
	"fontS28": `commonStyles-module__font-s-28___Jb5_C`,
	"fontW400": `commonStyles-module__font-w-400___gs4vx`,
	"fontW500": `commonStyles-module__font-w-500___m7jSl`,
	"fontW600": `commonStyles-module__font-w-600___X4Kbv`,
	"fontW700": `commonStyles-module__font-w-700___gHZxP`,
	"p5": `commonStyles-module__p-5___x1sz_`,
	"p12": `commonStyles-module__p-12___crbHK`,
	"p16": `commonStyles-module__p-16___NQRCX`,
	"p30": `commonStyles-module__p-30___JPupD`,
	"pB0": `commonStyles-module__p-b-0___S1Nts`,
	"pB5": `commonStyles-module__p-b-5___TO67k`,
	"pB10": `commonStyles-module__p-b-10___DwQsD`,
	"pB12": `commonStyles-module__p-b-12___I1_6Y`,
	"pB16": `commonStyles-module__p-b-16___akhnk`,
	"pB18": `commonStyles-module__p-b-18___Vj3b7`,
	"pB20": `commonStyles-module__p-b-20___ZeKGa`,
	"pB25": `commonStyles-module__p-b-25___svoQE`,
	"pB30": `commonStyles-module__p-b-30___tHpoc`,
	"pB50": `commonStyles-module__p-b-50___fAJHz`,
	"pT0": `commonStyles-module__p-t-0___CWbnC`,
	"pT12": `commonStyles-module__p-t-12___KymsU`,
	"pT16": `commonStyles-module__p-t-16___rWOdT`,
	"pT18": `commonStyles-module__p-t-18___JmZSN`,
	"pT20": `commonStyles-module__p-t-20___wRfmz`,
	"pT30": `commonStyles-module__p-t-30___RzBw6`,
	"pT40": `commonStyles-module__p-t-40___RZ4rO`,
	"pT50": `commonStyles-module__p-t-50___VyZN2`,
	"pL20": `commonStyles-module__p-l-20___zL91K`,
	"pL30": `commonStyles-module__p-l-30___BSnC0`,
	"pL40": `commonStyles-module__p-l-40___aiJMH`,
	"pR16": `commonStyles-module__p-r-16___a7mGe`,
	"pR20": `commonStyles-module__p-r-20___mvQTD`,
	"pR30": `commonStyles-module__p-r-30___Z1tFl`,
	"pR50": `commonStyles-module__p-r-50___s179c`,
	"pR60": `commonStyles-module__p-r-60___XiHrb`,
	"mB1": `commonStyles-module__m-b-1___Qk1A7`,
	"mB2": `commonStyles-module__m-b-2___YhFZ3`,
	"mB6": `commonStyles-module__m-b-6___vjzF1`,
	"mB8": `commonStyles-module__m-b-8___yn64D`,
	"mB10": `commonStyles-module__m-b-10___uAQlc`,
	"mB14": `commonStyles-module__m-b-14___CAJ60`,
	"mB16": `commonStyles-module__m-b-16___RwNLm`,
	"mB20": `commonStyles-module__m-b-20___OgsTK`,
	"mB22": `commonStyles-module__m-b-22___EJC84`,
	"mB24": `commonStyles-module__m-b-24___NzCwJ`,
	"mB30": `commonStyles-module__m-b-30___F5bSE`,
	"mB32": `commonStyles-module__m-b-32___hmtoV`,
	"mB40": `commonStyles-module__m-b-40___RLYDK`,
	"mT2": `commonStyles-module__m-t-2____nUej`,
	"mT3": `commonStyles-module__m-t-3___e4l7F`,
	"mT4": `commonStyles-module__m-t-4___UkjNo`,
	"mT5": `commonStyles-module__m-t-5___ggUKD`,
	"mT8": `commonStyles-module__m-t-8___u1zgb`,
	"mT10": `commonStyles-module__m-t-10___QW5UT`,
	"mT15": `commonStyles-module__m-t-15___SIMop`,
	"mT16": `commonStyles-module__m-t-16___G7__R`,
	"mT20": `commonStyles-module__m-t-20___j1Jg7`,
	"mT22": `commonStyles-module__m-t-22___vWJm1`,
	"mT30": `commonStyles-module__m-t-30___vOmmn`,
	"mT32": `commonStyles-module__m-t-32___mDS5K`,
	"mLAuto": `commonStyles-module__m-l-auto___ZlqzJ`,
	"mL4": `commonStyles-module__m-l-4___ncJOt`,
	"mL5": `commonStyles-module__m-l-5___pXoXc`,
	"mL6": `commonStyles-module__m-l-6___poXLB`,
	"mL8": `commonStyles-module__m-l-8___OJ6Hl`,
	"mL10": `commonStyles-module__m-l-10___nMNHP`,
	"mL16": `commonStyles-module__m-l-16___HN5L1`,
	"mL20": `commonStyles-module__m-l-20___Ej8MW`,
	"mL24": `commonStyles-module__m-l-24___lxH1c`,
	"mL30": `commonStyles-module__m-l-30___I3KxA`,
	"mL35": `commonStyles-module__m-l-35____DFBR`,
	"mL40": `commonStyles-module__m-l-40___pj8ip`,
	"mR8": `commonStyles-module__m-r-8___D3c4a`,
	"mR10": `commonStyles-module__m-r-10___tYGlC`,
	"mR16": `commonStyles-module__m-r-16___pNRb7`,
	"mR20": `commonStyles-module__m-r-20___YKhK4`,
	"mR24": `commonStyles-module__m-r-24___O7dgd`,
	"mR30": `commonStyles-module__m-r-30___PpJJD`,
	"mR40": `commonStyles-module__m-r-40___bVPM9`,
	"borderR3": `commonStyles-module__border-r-3___jWOSG`,
	"borderR4": `commonStyles-module__border-r-4___sEVEa`,
	"borderR6": `commonStyles-module__border-r-6___gqgfo`,
	"borderR10": `commonStyles-module__border-r-10___auUUN`,
	"borderR12": `commonStyles-module__border-r-12___x3Qks`,
	"borderR16": `commonStyles-module__border-r-16___oLpxu`,
	"borderR50": `commonStyles-module__border-r-50___ewkz5`,
	"primaryBorder": `commonStyles-module__primary-border___rOEe7`,
	"primaryBorderB": `commonStyles-module__primary-border-b___sJgPE`,
	"primaryBorderT": `commonStyles-module__primary-border-t___mezW3`,
	"primaryBorderL": `commonStyles-module__primary-border-l___uuNlR`,
	"primaryBorderR": `commonStyles-module__primary-border-r___mns8z`,
	"secondaryBorder": `commonStyles-module__secondary-border___CWkST`,
	"secondaryBorderB": `commonStyles-module__secondary-border-b___fkw6m`,
	"secondaryBorderT": `commonStyles-module__secondary-border-t___bo5U2`,
	"secondaryBorderL": `commonStyles-module__secondary-border-l___Zb0lV`,
	"secondaryBorderR": `commonStyles-module__secondary-border-r___z_rQm`,
	"gap0": `commonStyles-module__gap-0___bzPD3`,
	"gap2": `commonStyles-module__gap-2___ekOZ1`,
	"gap4": `commonStyles-module__gap-4___TXxEo`,
	"gap5": `commonStyles-module__gap-5___L4ieK`,
	"gap6": `commonStyles-module__gap-6___n7QQS`,
	"gap8": `commonStyles-module__gap-8___P5n9z`,
	"gap10": `commonStyles-module__gap-10___EypVI`,
	"gap12": `commonStyles-module__gap-12___A6092`,
	"gap14": `commonStyles-module__gap-14___Sj7GR`,
	"gap16": `commonStyles-module__gap-16___Qruby`,
	"gap18": `commonStyles-module__gap-18___uRwGR`,
	"gap20": `commonStyles-module__gap-20___OJ1Jx`,
	"gap24": `commonStyles-module__gap-24___Z8yMv`,
	"gap26": `commonStyles-module__gap-26___EKNjN`,
	"gap30": `commonStyles-module__gap-30___d7cSM`,
	"gap32": `commonStyles-module__gap-32___IhbVe`,
	"gap40": `commonStyles-module__gap-40___m5SaJ`,
	"gap50": `commonStyles-module__gap-50____AmzV`,
	"flex1": `commonStyles-module__flex-1___InhiG`,
	"flexNone": `commonStyles-module__flex-none___Vk0UU`,
	"flexColumn": `commonStyles-module__flex-column___QAVZA`,
	"flexRow": `commonStyles-module__flex-row___qWV3g`,
	"verticallyCentered": `commonStyles-module__vertically-centered___V5Av7`,
	"horizontallyCentered": `commonStyles-module__horizontally-centered___slDYb`,
	"horizontallyEnd": `commonStyles-module__horizontally-end___o0mXy`,
	"verticallyStart": `commonStyles-module__vertically-start___Btf4Y`,
	"spaceBetween": `commonStyles-module__space-between___KHoVv`,
	"flexWrap": `commonStyles-module__flex-wrap___t9g1O`,
	"height100": `commonStyles-module__height-100___ONsnK`,
	"width50": `commonStyles-module__width-50___QBMGB`,
	"width100": `commonStyles-module__width-100___gNYLm`,
	"cursorPointer": `commonStyles-module__cursor-pointer___xAvbC`,
	"cursorNotAllowed": `commonStyles-module__cursor-not-allowed___cgLu6`,
	"absoluteCentered": `commonStyles-module__absolute-centered___ZECYn`,
	"absolute": `commonStyles-module__absolute___mJu3N`,
	"relative": `commonStyles-module__relative___aIUJ_`,
	"fixed": `commonStyles-module__fixed___AQEmA`,
	"visible": `commonStyles-module__visible___cfth9`,
	"invisible": `commonStyles-module__invisible___F8jgn`,
	"col90": `commonStyles-module__col-90___dO8li`,
	"colAuto": `commonStyles-module__col-auto___zsHMK`,
	"medicalTabs": `commonStyles-module__medical-tabs___ulisv`,
	"medicalTableNew": `commonStyles-module__medical-table-new___F08z7`,
	"noPagination": `commonStyles-module__no-pagination___Clpnv`,
	"medicalTableEmpty": `commonStyles-module__medical-table-empty___Ha8la`,
	"iconBtn": `commonStyles-module__icon-btn___K1ijf`,
	"searchIcon": `commonStyles-module__search-icon___H4_P5`,
	"disableSelect": `commonStyles-module__disable-select___ZWgiQ`,
	"breakWord": `commonStyles-module__break-word___nwAjB`,
	"popupClearBtn": `commonStyles-module__popup-clear-btn___vcGyr`,
	"scrollMB20": `commonStyles-module__scroll-m-b-20___NzcI3`,
	"container": `commonStyles-module__container___swhj1`,
	"actionsMenu": `commonStyles-module__actionsMenu___vNg9n`,
	"actionButton": `commonStyles-module__actionButton___c36fT`,
	"link": `commonStyles-module__link___mGWKc`,
	"preferred": `commonStyles-module__preferred___nVTQd`
};
module.exports = ___CSS_LOADER_EXPORT___;
